export const onClientEntry = () => {
    // Uncomment the following lines to test Rollbar error tracking
    // if (typeof window !== "undefined" && window.Rollbar) {
    //     window.Rollbar.error("Test error from Gatsby!");
    // }
};
